import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Footer from '../../../../components/footer/';

class BottomFooter extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { bottomAd, footer } = content;

        return (
            <div className={styles.bottomFooter}>
                <div className={styles.bottomAd_box}>
                    <Ad content={bottomAd} styleName={styles.bottomAd} />
                </div>
                <Footer content={footer} />
            </div>
        );
    }
}

export default errorBoundary(BottomFooter);
